class TimelineFeeling {
	static fromArray(timeline, data) {
		let inst = new TimelineFeeling(timeline);
		inst._id = data.shift();
		inst._name = data.shift();
		inst._graphic = data.shift();
		inst._color = data.shift();
		return inst;
	}

	constructor (timeline) {
		this._timeline = timeline;
		this._id;
		this._name;
		this._graphic;
		this._color;
	}
	get id () {return this._id;}
	get graphic () {return this._graphic;}
	get color () {return this._color;}
}